import I18n from 'I18n';
import PropTypes from 'prop-types';
import { Component } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIForm from 'UIComponents/form/UIForm';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import FullNameInput from 'ui-addon-i18n/components/FullNameInput';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class BlankNameModal extends Component {
  render() {
    const {
      stagedFirstName,
      stagedLastName,
      validFirstName,
      validLastName
    } = this.props;
    return /*#__PURE__*/_jsxs(UIModal, {
      size: "auto",
      use: "conversational",
      children: [/*#__PURE__*/_jsx(UIDialogHeader, {
        children: /*#__PURE__*/_jsx(H2, {
          children: I18n.text('userPreferences.labels.whatsYourName')
        })
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: /*#__PURE__*/_jsx(UIForm, {
          children: /*#__PURE__*/_jsx(FullNameInput, {
            givenNameInput: /*#__PURE__*/_jsx(UIFormControl, {
              error: !!stagedFirstName && !validFirstName,
              validationMessage: stagedFirstName && !validFirstName && I18n.text('userPreferences.labels.invalidName'),
              children: /*#__PURE__*/_jsx(UITextInput, {
                value: stagedFirstName,
                onChange: this.props.onStagedFirstNameChanged,
                "data-test-id": "first-name"
              })
            }),
            familyNameInput: /*#__PURE__*/_jsx(UIFormControl, {
              error: !!stagedLastName && !validLastName,
              validationMessage: stagedLastName && !validLastName && I18n.text('userPreferences.labels.invalidName'),
              children: /*#__PURE__*/_jsx(UITextInput, {
                value: stagedLastName,
                onChange: this.props.onStagedLastNameChanged,
                "data-test-id": "last-name"
              })
            })
          })
        })
      }), /*#__PURE__*/_jsx(UIDialogFooter, {
        align: "center",
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          "data-test-id": "name-submit-button",
          onClick: this.props.onSaveName,
          disabled: !validFirstName || !validLastName,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.labels.save"
          })
        })
      })]
    });
  }
}
BlankNameModal.propTypes = {
  stagedFirstName: PropTypes.string.isRequired,
  stagedLastName: PropTypes.string.isRequired,
  validFirstName: PropTypes.bool.isRequired,
  validLastName: PropTypes.bool.isRequired,
  onSaveName: PropTypes.func.isRequired,
  onStagedFirstNameChanged: PropTypes.func.isRequired,
  onStagedLastNameChanged: PropTypes.func.isRequired
};
export default BlankNameModal;